/* eslint-disable */
import {json2query} from '@/utils'
import {APIRegisterUser, APISendVerifyCode} from '@/apis/APIAuth.js'
import {getCookie} from '@/tools/'

/* 
用户注册
/user2/RegisterUser       post(formData)
  *payload             json数据，User对象(手机号必填)
  *mobileVerifyCode    手机验证码（通过auth2.SendVerifyCode获得）
  authToken            之前通过login得到的认证TOKEN（可以为空）

  ----payload
  UserID2  str    用户名(英文数字下划线)
  Name     str    昵称
  Mobile   str    手机号
  Email    string `orm:"size(32)" json:"email"`
  IDCardNo string `orm:"size(18);column(id_card_no)" json:"idCardNo"` // 身份证号
*/
// 通过手机号注册
/**
 * 
 * @param {*} mobile 手机号
 * @param {*} mobileVerifyCode 验证码
 * @param {*} noLoading 
 */
export const registerUser = async (mobile, mobileVerifyCode, noLoading = true) => {
  try {
    let res = await APIRegisterUser(json2query({
      payload: JSON.stringify({
        userID2: mobile,
        name: mobile,
        mobile
      })
      // mobileVerifyCode
      // authToken: getCookie('Token')
    }), noLoading)
    return res
  } catch (e) {
    throw e
  }
}

/* 
发送验证码
/auth2/SendVerifyCode         post
  captchaID         str         图片验证码ID
  captchaValue      str         图片验证码值
  authToken          str         之前的认证token
  *authID            str         手机号或邮件
*/
export const sendCode = async (mobile, noLoading = true) => {
  try {
    let res = await APISendVerifyCode(json2query({
      authID: mobile,
      authToken: getCookie('Token')
    }), noLoading)
    return res
  } catch (e) {
    throw e
  }
}


// WEBPACK FOOTER //
// ./src/apis/controls/auth.js